/*
 * @description: 中文说明
 * @author: zb
 * @update: zb
 * @LastEditors: zb
 * @Date: 2019-04-24 13:55:32
 * @LastEditTime: 2019-05-17 10:42:27
 */

import formReset from './formResetDirective.js'

import loginShow from './loginShowDirective'

function Directives() {}

Directives.install = function(Vue) {
  Vue.directive('formReset', formReset)
  Vue.directive('login-show', loginShow)
}

const DIRECTIVES = [formReset]
export { Directives }
export default DIRECTIVES
